import { Component, inject } from '@angular/core';
import { MapWallDisplayFacade } from '../../store/map-wall-display.facade';
import { WallDisplayWidgetConfigComponent } from '../wall-display-widget-config/wall-display-widget-config.component';
import {
  AlertFeedWidgetComponent,
  AlertStatusCountsWidgetComponent,
  ImageCardWidgetComponent,
  LocationCardsWidgetComponent,
  MapLegendWidgetComponent,
  TimeCardsWidgetComponent
} from '../wall-display-widgets';

@Component({
    selector: 'topo-map-wall-display-overlay',
    imports: [
        AlertFeedWidgetComponent,
        AlertStatusCountsWidgetComponent,
        ImageCardWidgetComponent,
        LocationCardsWidgetComponent,
        MapLegendWidgetComponent,
        TimeCardsWidgetComponent,
        WallDisplayWidgetConfigComponent
    ],
    templateUrl: './map-wall-display-overlay.component.html',
    styleUrl: './map-wall-display-overlay.component.scss'
})
export class MapWallDisplayOverlayComponent {
  state = inject(MapWallDisplayFacade);
}
